// Libs
import { prop } from 'ramda'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { SessionState, sessionStoreKey } from 'core/session/sessionReducers'
import { IUsersSelector } from './model'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { deleteUser } from './new-actions'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'

interface Props {
  rows: IUsersSelector[]
  onClose: (success: boolean) => void
}

const UserDeleteDialog = ({ rows: [user], onClose }: Props) => {
  if (!user) {
    return null
  }
  const session = useSelector(prop<string, SessionState>(sessionStoreKey))
  const {
    userDetails: { id = '' },
  } = session

  const { update: deleteFn, updating: deletingUser } = useUpdateAction(deleteUser)
  const isSignedInUser = user?.id === id

  const extraMessage = isSignedInUser
    ? [
        'Warning, you are about to delete the user associated with your current login.',
        <br />,
        'Doing so will terminate your session, you will be logged out',
        <br />,
        'and you will no longer be able to access this account.',
      ]
    : ''

  const handleDelete = useCallback(async () => {
    await deleteFn({ id: user.id })
    onClose(true) // need to put true here so that the grid refreshes
  }, [user])

  return (
    <Modal
      panel="dialog"
      open
      onClose={onClose}
      title={`Delete "${user.username}" ?`}
      maxWidth={600}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} loading={false} disabled={deletingUser}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingUser}>
            Confirm
          </Button>
        </>
      }
    >
      {extraMessage && <Text variant="body2">{extraMessage}</Text>}
      <Text variant="body2">
        This action cannot be undone, are you sure you want to delete this user ?
      </Text>
    </Modal>
  )
}

export default UserDeleteDialog
